import * as React from 'react';
import { connect } from 'react-redux';

interface CalendarModeProps {
    xlinkHref: string;
    text: string;
    onClick: (evt: React.MouseEvent<HTMLButtonElement>) => any;
    isSelected: boolean;
}

const calendarMode: React.SFC<CalendarModeProps> = (props) => {
    function onClick(evt: React.MouseEvent<HTMLButtonElement>) {
        evt.preventDefault();

        props.onClick(evt);
    }

    return (
        <button className={`cal-mode-option ${(props.isSelected ? 'active' : '')}`} onClick={props.onClick} >
            <span>
                <svg className="svg-icon-md">
                    <use xlinkHref={props.xlinkHref} />
                </svg>

                <span>{props.text}</span>
            </span>
        </button>
    );
}

export default calendarMode;


// WEBPACK FOOTER //
// ./node_modules/source-map-loader!./app/calendar/views/calendar-mode.tsx